module.exports = __webpack_public_path__ + "static/media/zameen-construction-guide.fb59cc6d.jpg";